"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Briefcase, DollarSign, Target, Users } from "lucide-react";
const services = [{
  id: 1,
  icon: Briefcase,
  title: "Business Operational Guidance",
  description: "Expert consulting to optimize your day-to-day operations and streamline processes for maximum efficiency."
}, {
  id: 2,
  icon: DollarSign,
  title: "Financial Management Improvement",
  description: "Comprehensive financial planning and management strategies to strengthen your business's fiscal health."
}, {
  id: 3,
  icon: Target,
  title: "Strategic Planning Development",
  description: "Actionable roadmaps and strategic frameworks designed to drive sustainable growth and performance."
}, {
  id: 4,
  icon: Users,
  title: "Customized Workshops & Advisory",
  description: "One-on-one sessions and tailored workshops to address your unique business challenges and goals."
}];
export default function ServiceListings() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className={`mx-auto max-w-7xl transition-all duration-[300ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <div className="text-center mb-12">
          <h2 className="text-foreground mb-4">Our Services</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Professional consulting and educational services designed to guide your business toward operational excellence and sustainable growth.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <Card key={service.id} data-index={i} className="bg-muted border border-border flex flex-col transition-all duration-[150ms] ease-in-out hover:scale-[1.02] hover:shadow-medium">
                <CardHeader className="items-center">
                  <div className="mb-4">
                    <IconComponent className="size-12 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-center text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-1">
                  <p className="text-muted-foreground text-center text-sm">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="justify-center">
                  <Button asChild variant="ghost" size="sm" className="transition-transform duration-[150ms] ease-in-out hover:scale-[1.02]">
                    <Link to="#" className="text-primary">
                      Learn More
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}